import { render, staticRenderFns } from "./LoginBengkulu.vue?vue&type=template&id=2eecfe68&lang=pug"
import script from "./LoginBengkulu.vue?vue&type=script&lang=js"
export * from "./LoginBengkulu.vue?vue&type=script&lang=js"
import style0 from "../../../assets/style/bengkulu/login-bkl.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports